module.exports = __webpack_public_path__ + "static/img/inter.07a607b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/inter.png
// module id = CERd
// module chunks = 1